import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { browserHistory } from 'react-router';

import DonationCard from '../DonationCard';
import ShareModal from '../ShareModal';
import AdSection from '../AdSection';
import SiteNav from '../SiteNav';
import GetLinkCard from '../GetLinkCard';
import MyEverdaysPanel from '../MyEverdaysPanel';
import FbShareBtn from '../FbShareBtn';
import FbShareSection from '../FbShareSection';

import { getBaseRoute } from '../WebCommunity';
import { useScrollToTop, useFBShareRender } from '@evdy/web-core/dist/customHooks';

import { webCommunityOperations } from '@evdy/web-redux/dist/lib/webCommunity';

import styles from './DonationsDetails.module.scss';

const {
  'donations-details': donationsDetailsClass,
  'donations-contents': donationsContentsClass,
  'donations-column': donationsColumnClass,
  'donations-header': donationsHeaderClass,
  'title-container': titleContainerClass,
  'donations-section': donationsSectionClass,
  'my-everdays-panel-container': myEverdaysPanelContainerClass,
  'decedent-bar-btn': decedentBarBtnClass
} = styles;

const { trackAds } = webCommunityOperations; // is this different depending on where it's used, or can this live in AdSection?

const DonationsDetails = ({ location }) => {
  const { inviteMetaData } = useSelector(({ webCommunity }) => ({
    inviteMetaData: webCommunity?.inviteMeta?.data
  }));

  const { _id: memorialId, donations = [], ads = [], shareUrl } = inviteMetaData || {};

  const [isShareModalOpen, setShareModalOpen] = useState(false);

  const placementType = 'communityDonationDetails';
  const findAdsCb = ({ placementType: adDataPlacementType }) =>
    placementType === adDataPlacementType;
  const donationDetailsAdData = !!ads.length && ads.find(findAdsCb);

  // scroll to top on mount
  useScrollToTop();

  // parse fb share content to be visible when navigating pages
  useFBShareRender();

  const handleGoBack = () => browserHistory.push(getBaseRoute(location.pathname));

  const handleToggleShareMenu = () => {
    setShareModalOpen(prev => !prev);
  };

  const DecedentBarBtn = () => (
    <button className={decedentBarBtnClass} onClick={handleToggleShareMenu}>
      Share
    </button>
  );

  return (
    <div className={donationsDetailsClass}>
      <SiteNav showDecedentBar decedentBarContent={DecedentBarBtn} />
      <div className={donationsContentsClass}>
        <div className={donationsColumnClass}>
          <div className={donationsHeaderClass}>
            <button onClick={handleGoBack}>← Back</button>
            <div className={titleContainerClass}>
              <h2>Donations</h2>
              <FbShareBtn {...{ shareUrl }} />
            </div>
          </div>
          <div className={donationsSectionClass}>
            {donations?.map((donation, idx) => (
              <DonationCard key={`${donation?.title}-${idx}`} {...donation} />
            ))}
          </div>
        </div>
        {/* <div className={myEverdaysPanelContainerClass}>
          <MyEverdaysPanel />
        </div> */}
      </div>
      <FbShareSection {...{ shareUrl }} />
      <GetLinkCard />
      <AdSection {...{ trackAds, memorialId }} adData={donationDetailsAdData} />
      <ShareModal
        closeModal={handleToggleShareMenu}
        modalVisible={isShareModalOpen}
        shareUrl={shareUrl}
      />
    </div>
  );
};

export default DonationsDetails;
